module.exports = __webpack_public_path__ + "static/media/roller08.470a8a6a.png";